import { useRef, shallowEqual } from '@web-stories-wp/react';
import { hasGradient } from '@web-stories-wp/patterns';
import { hasSemanticList } from './listStyle';
import type { TextElement } from '../../types';

export default function useTextLayoutElement(element: TextElement) {
  const { textDepth, textInnerGlow, ...layout } = element;
  const fill = useRef(layout.color);
  // SVG definitions own ordinary gradient paint. List spans still carry their
  // inherited marker colour and must refresh when that colour changes.
  if (
    !hasGradient(layout.color) ||
    !hasGradient(fill.current) ||
    hasSemanticList(layout.content)
  ) {
    fill.current = layout.color;
  }
  layout.color = fill.current;
  const previous = useRef(layout);
  // These effects paint the fill without changing glyphs or line geometry.
  if (!shallowEqual(previous.current, layout)) previous.current = layout;
  return previous.current;
}
